export const transformMissingDocumentsResponse = (
  responseArray: any[],
  allMonths: string[],
): any[] =>
  responseArray.reduce(
    (acc: any, currentCol: any, index: number) => {
      const { collector, unit, days } = currentCol;

      const byMonth: Record<string, any[]> = days.reduce(
        (monthGroup: Record<string, any[]>, d: any) => {
          const monthName = allMonths[parseInt(d.day.substring(5, 7), 10) - 1];
          return {
            ...monthGroup,
            [monthName]: [...(monthGroup[monthName] ?? []), d],
          };
        },
        {},
      );

      const months = Object.entries(byMonth).reduce(
        (monthAcc: any, [monthName, monthDays]) => {
          const uniqueBillTypes = Array.from(
            new Set(monthDays.map((d: any) => d.billType).filter(Boolean)),
          );
          const hasActual = uniqueBillTypes.includes("ACTUAL");
          const hasInterpolationOrExtrapolation =
            uniqueBillTypes.includes("INTERPOLATION") ||
            uniqueBillTypes.includes("EXTRAPOLATION");

          return {
            ...monthAcc,
            [monthName]: {
              days: monthDays.map(
                ({
                  day,
                  usage,
                  billType,
                }: {
                  day: string;
                  usage: number;
                  billType: string;
                }) => ({
                  day: day.substring(8),
                  usage,
                  dayBillType: billType,
                }),
              ),
              monthBillType:
                uniqueBillTypes.length > 1 &&
                hasActual &&
                hasInterpolationOrExtrapolation
                  ? "MIXED"
                  : uniqueBillTypes[0] ?? null,
              monthUsage: monthDays.reduce(
                (usageAcc: number, d: any) => usageAcc + (d.usage ?? 0),
                0,
              ),
            },
          };
        },
        {},
      );

      acc[index] = {
        id: collector.id,
        collector,
        unit,
        months,
        status: collector?.collectorStatus ?? "",
      };

      return acc;
    },
    [],
  );
